import { toast } from "react-toastify";

const sendErrorToast = (message: string) => {
  toast(message, {
    type: "error",
  });
  return;
};
export default sendErrorToast;
